module.exports = __webpack_public_path__ + "img/font-football-blue.fae21148.png";